import { parse, Url } from 'url';
import { parse as parseQuery, ParsedUrlQuery } from 'querystring';
import { Actions } from 'interfaces/store';
import { isEmpty } from 'lodash-es';

export const getQueryParameter = (urlString: string, paramName: string): string => {
  const url = parse(urlString);
  const queryParamsString: string = url.query || '';
  const queryParams: ParsedUrlQuery = parseQuery(queryParamsString);
  const value: string | string[] = (queryParams && queryParams[paramName]) || [];
  return value ? value.toString() : '';
};

export const getPathVariableFromEnd = (urlString: string, countFromEnd: number): string => {
  const url: Url = parse(urlString);
  const pathVariables: string[] | undefined = url.pathname?.split('/');

  return pathVariables ? pathVariables[pathVariables.length - countFromEnd] : '';
};

export const getApiDomain = (): string => {
  return process.env.REACT_APP_API_DOMAIN || '';
};

export const getSearchApiDomain = (): string => {
  return process.env.REACT_APP_CORE_API_DOMAIN || '';
};

export const getFeedbackApiDomain = (): string => {
  return process.env.REACT_APP_FEEDBACK_DOMAIN || '';
};

export const getAppBaseUrl = () => {
  const baseUrl = getAppDomainUrl();
  return baseUrl + '/services/disability-worker-registration';
};

export const getAppDomainUrl = () => {
  const baseUrl = process.env.REACT_APP_DOMAIN || '';
  return baseUrl;
};

export const getAuthDomain = () => getEnvValue(process.env.REACT_APP_AUTHORITY_URL, getApiDomain());

export const getIdvDomain = () => getEnvValue(process.env.REACT_APP_IDV, getApiDomain());

export const getNpcDomain = () => getEnvValue(process.env.REACT_APP_NPC, getAppDomainUrl());

export const getAssessmentDomain = () =>
  getEnvValue(process.env.REACT_APP_ASSESSMENT, getApiDomain());

export const getSaveResumeDomain = () =>
  getEnvValue(process.env.REACT_APP_SAVE_RESUME, getApiDomain());

export const getPaymentDomain = () =>
  getEnvValue(process.env.REACT_APP_PAYMENT_DOMAIN, getApiDomain());

export const getCustomerDomain = () =>
  getEnvValue(process.env.REACT_APP_CUSTOMER_DOMAIN, getApiDomain());

export const getAddressDomain = () =>
  getEnvValue(process.env.REACT_APP_ADDRESS_DOMAIN, getApiDomain());

export const getFileUploadDomain = () =>
  getEnvValue(process.env.REACT_APP_FILE_UPLOAD_DOMAIN, getApiDomain());

export const getWestpacUrl = (): string => getEnvValue(process.env.REACT_APP_WESTPAC_URL, '');

export const getWestpacKey = (): string => getEnvValue(process.env.REACT_APP_WESTPAC_KEY, '');

export const doUglyStateFix = (stepId: string, actions: Actions): void => {
  //   actions.updateInitialStep(stepId);
  const homeUrl = getAppBaseUrl() + '/transaction';
  document.location.href = homeUrl;
};

const getEnvValue = (value?: string, defaultValue?: string): string => {
  return isEmpty(value) ? defaultValue || '' : value || '';
};

export const getWestpacBusinessCode = (): string =>
  process.env.REACT_APP_WESTPAC_BUSINESS_CODE || '';
